import React, { Component, Fragment } from "react";
import Navigate from "../../../shared/navigation/navigate";
import { formatDateRange } from "../../challenges/utils";

class ChallengesContainer extends Component {
  getProgressClass = (progress) => {
    if (progress >= 3) return "three-completed";
    if (progress >= 2) return "two-completed";
    if (progress >= 1) return "one-completed";
    return "";
  };

  render() {
    const { challengeInfo, userProgress, challengePath } = this.props;
    const progressClass = this.getProgressClass(userProgress);

    return (
      <Fragment>
        <div className="challenges-container">
          <div>
            <h3 className="challenges-header">Challenges</h3>
          </div>
          <div>
            <div className="challenge-title-row">
              <div className="circle-indicator">
                <div className="circle-indicator-inner"></div>
              </div>
              <div className="challenge-subheader">
                <h3 className="challenge-title-h3 truncate-multiline">
                  {challengeInfo ? challengeInfo.name : ""}
                </h3>
                <div>
                  <div className={`progress-bar ${progressClass}`}>
                    <div className="progress-bar-segment" />
                    <div className="progress-bar-segment" />
                    <div className="progress-bar-segment" />
                  </div>
                  <div className="progress-status">
                    {userProgress} of 3 scores posted •{" "}
                    {challengeInfo?.days_left} days left
                  </div>
                </div>
              </div>
            </div>
            <div className="challenge-info">
              <div className="challenge-info-item">
                <div className="usga-calendar-small" />
                <span>
                  {!challengeInfo
                    ? ""
                    : formatDateRange(
                        challengeInfo?.start_date,
                        challengeInfo?.end_date
                      )}
                </span>
              </div>
              <div className="challenge-info-item">
                <div className="people-small" />
                <span>
                  {!challengeInfo ? "" : `${challengeInfo?.golfers} golfers`}
                </span>
              </div>
              <div className="challenge-info-item">
                <div className="golfcup-small" />
                <span>3+ rounds to qualify</span>
              </div>
            </div>
          </div>
          <div className="join-button-container">
            <button
              className="btn outline blue"
              onClick={() =>
                Navigate.toPath(challengePath + "/" + challengeInfo?.id)
              }
            >
              VIEW CHALLENGE
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ChallengesContainer;
